import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Link from 'react-router/lib/Link';
import HeroCardElements from './hero_card_elements';
import OpenerImage from '../common/opener_image';
import { sendAnalyticsEvent, sendDataLayerEvent } from '../../utils/analytics';
import {
  ROW_TYPE_ONE_FEATURED_STORY
} from '../../constants';

export default class HeroCard extends Component {
  handleClick = () => {
    if (this.props.rowType === ROW_TYPE_ONE_FEATURED_STORY) {
      sendAnalyticsEvent(
        'Featured Story',
        'Click',
        this.props.url
      );

      sendDataLayerEvent(
        'Click',
        {
          pageModule: 'Featured story',
          linkUID: this.props.id,
          linkURL: this.props.url,
          linkType: 'article',
          itemIndex: 0,
          linkTitle: this.props.truncated_title_62,
          itemName: this.props.truncated_title_62,
          linkHeadline: this.props.truncated_title_62
        }
      );

      return;
    }

    sendAnalyticsEvent(
      'Hero Stories',
      'Click',
      `Hero Story ${this.props.indexWithinModule}`
    );

    sendDataLayerEvent(
      'Click',
      {
        module_name: 'Hero',
        cta_text: this.props.truncated_title_62,
        destination_url: this.props.url,
        position: this.props.indexWithinModule - 1,
        linkUID: this.props.id,
        linkType: 'article',
        linkTitle: this.props.truncated_title_62,
        itemName: this.props.truncated_title_62,
        linkHeadline: this.props.truncated_title_62
      },
    );
  }

  render() {
    const { rowType, isVideoCard, url, opener_images, ...heroCardElements } = this.props;
    const { isHomepageRefresh } = heroCardElements;

    const openerImageProps = { isVideoCard, rowType, opener_images };
    const isRefreshCard = isHomepageRefresh && rowType === ROW_TYPE_ONE_FEATURED_STORY;

    return (
      <div onClick={this.handleClick} className="hero-card-full-width">
        <Link to={url}>
          <OpenerImage {...openerImageProps} />
          <HeroCardElements {...heroCardElements}
            isRefreshCard={isRefreshCard}
            isVideoCard={isVideoCard}
          />
        </Link>
      </div>
    );
  }
}

HeroCard.propTypes = {
  cardID: PropTypes.number.isRequired,
  rowType: PropTypes.string.isRequired,
  indexWithinModule: PropTypes.number.isRequired,
  url: PropTypes.string.isRequired,
  isVideoCard: PropTypes.bool,
  opener_images: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    asset: PropTypes.object
  })).isRequired,
  contributors: PropTypes.arrayOf(PropTypes.shape({
    display_name: PropTypes.string
  })).isRequired,
  id: PropTypes.number.isRequired,
  pageId: PropTypes.number.isRequired,
  truncated_title_62: PropTypes.string.isRequired,
  isHomepageRefresh: PropTypes.bool
};

HeroCard.defaultProps = {
  type: '',
  opener_images: [{
    type: '',
    asset: {
      src: { full: '' }
    }
  }],
  contributors: [{}],
  indexWithinModule: 0,
  meta: {},
  cardID: 0
};
